import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LuxLoader } from "@/components/LuxLoader";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-white">
        <LuxLoader label="Preparing your session" />
      </div>
    );
  }
  if (!user) {
    const to = adminOnly ? "/admin/login" : "/login";
    return <Navigate to={to} replace state={{ from: location.pathname }} />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
